"use client";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CardProduct from "@/util/view/CardProduct";
import PaginationView from "@/util/view/PaginationView";
import Link from "next/link";
import { ProductListOrderType } from "../product/product";
import { CategoryType } from "./CatType";
import AttributeListCategories from "./components/AttributeListCategories";
import SortProduct from "./components/SortProduct";

interface Props {
  cat: CategoryType;
  page: number;
  products: ProductListOrderType;
  pathname: string;
}
const CategoriesView = ({ cat, page, products, pathname }: Props) => {
  return (
    <div>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link href="/">خانه</Link>
          </BreadcrumbItem>
          <span>/</span>
          <BreadcrumbItem>
            <BreadcrumbPage>{cat.data.cat_title}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <hr className="my-3" />
      <div className="flex flex-wrap">
        <div className="hidden lg:block w-[20%] my-10">
          <Card>
            {/* <BrandListCategories catId={cat.data.id} url={pathname} /> */}
            <AttributeListCategories catId={cat.data.id} url={pathname} />
          </Card>
        </div>
        <div className="lg:w-[80%] w-full">
          <>
            <div className="flex lg:justify-end justify-between">
              <Dialog>
                <DialogTrigger asChild>
                  <Button className="block lg:hidden">فیلتر ها</Button>
                </DialogTrigger>
                <DialogContent className="h-[600px] w-[350px] overflow-auto">
                  <DialogHeader>
                    <DialogTitle>فیلتر ها</DialogTitle>
                  </DialogHeader>
                  <div className="overflow-auto max-h-[desired-height]">
                    {/* <BrandListCategories catId={cat.data.id} url={pathname} /> */}
                    <AttributeListCategories
                      catId={cat.data.id}
                      url={pathname}
                    />
                  </div>
                </DialogContent>
              </Dialog>
              <SortProduct url={pathname} />
            </div>
            <div className="flex flex-wrap justify-between">
              {products?.data?.rows.map((i) => (
                <div
                  key={i.id}
                  className="lg:w-[33%] md:w-[50%] sm:p-1 py-2 px-0 w-full"
                >
                  <CardProduct data={i} key={i.product_title} />
                </div>
              ))}
              <PaginationView total={products.data?.count} url={pathname} />
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default CategoriesView;
